<template>
    <!-- 下拉选择器 -->
    <el-select
        :style="'width:'+width+'px'" 
        :value="value" 
        :placeholder="placeholder"
        :size="size"
        :filterable="allowCreate"
        :allow-create="allowCreate"
        :default-first-option="allowCreate"
        :clearable="clearable"
        @change="changeValue">
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        model: {
            prop: "value"
        },
        props: {
            width: {
                type: Number,
                default: 132
            },
            size: {
                type: String,
                default: "small"
            },
            placeholder: {
                type: String,
                default: "请选择"
            },
            clearable: {       // 是否可清空
                type: Boolean,
                default: true
            },
            allowCreate: {     // 是否可创建条目
                type: Boolean,
                default: false
            },
            filterable: {     // 是否可搜索
                type: Boolean,
                default: false
            },
            options: {           // 可选项
                type: Array,
                required: true,
                default() {
                    return []
                }
            },
            value: {
                type: [String,Boolean,Number],
                default: ""
            },
        },
        methods: {
            // 选择option
            changeValue(e) {
                this.$emit("input",e);
                this.$emit("change",e);
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/components/SelectBox.vue